import { createSlice } from "@reduxjs/toolkit";
import { caseChecklistVerificationAction } from "../../actions/CaseChecklistTab/caseChecklistTabAction";

const initialState = {
  checklistData: [],
  loading: false,
  error: null,
};

const checklistVerificationSlice = createSlice({
  name: "checklistVerification",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(caseChecklistVerificationAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(caseChecklistVerificationAction.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload?.data?.length) {
          state.checklistData = Object.values(action.payload.data[0]);
        } else {
          state.checklistData = [];
        }
      })

      .addCase(caseChecklistVerificationAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default checklistVerificationSlice.reducer;
